import { createSelector } from '@reduxjs/toolkit';

import { PaymentStates } from '@cashier/cashier-model';

import {
  PAYMENT_SNAPSHOT_FEATURE_KEY,
  PaymentSnapshotState,
} from './paymentSnapshot.slice';

export const getPaymentInfoState = (rootState: any): PaymentSnapshotState =>
  rootState[PAYMENT_SNAPSHOT_FEATURE_KEY];

export const selectPaymentCurrentState = createSelector(
  getPaymentInfoState,
  (s) => (s.paymentAttribute?.state as PaymentStates) || null,
);
